"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CheckboxGroupField", {
  enumerable: true,
  get: function get() {
    return _CheckboxGroupField["default"];
  }
});
exports["default"] = void 0;

var _CheckboxGroupField = _interopRequireWildcard(require("../CheckboxGroupField"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _CheckboxGroupField.CheckboxGroup;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/CheckboxGroup.js
// module id = 487
// module chunks = 0